import { DonationInitiativeDTO } from "../dto/DonationInitiativesDTO";
import { DonationInitiative } from "../models/DonationInitiatives";

export const donationInitiativesMapper = (dto: DonationInitiativeDTO) => {
  return new DonationInitiative({
    initiativeId: dto.initiativeId,
    initiativeName: dto.initiativeName || null,
    active: dto.active === "Y",
    displayOrder: dto.displayOrder || null,
  });
};
